export default function objectToFormData(obj) {
  if (obj === Object(obj)) {
    var data = new FormData();
    Object.entries(obj).forEach(function (_ref) {
      var key = _ref[0],
          value = _ref[1];

      data.append(key, value);
    });
    return data;
  } else {
    return obj;
  }
}